import request from '../utils/request'
import setting from './apiSetting'
import { getEffectiveTimezone } from '../utils/timezone'

const TYPE = 'Login'

const myfunction = {
  /**
   * 兼容旧调用名的登录入口。
   * 安全整改(2026-08)：原实现是 GET + query，账号密码会出现在 URL 上；
   * 后端 Login/UserLogin 已移除 HttpGet，这里统一改为走 POST 请求体。
   * 新代码请直接使用 possLogin()。
   */
  getLogin: function (data) {
    var src = data || {}
    var formData = new FormData()
    formData.append('language', src.language || 'zh-cn')
    formData.append(
      'timezone',
      String(src.timezone === undefined || src.timezone === null ? getEffectiveTimezone() : src.timezone)
    )
    Object.keys(src).forEach(function (key) {
      if (key !== 'language' && key !== 'timezone' && src[key] !== undefined && src[key] !== null) {
        formData.append(key, src[key])
      }
    })

    return myfunction.possLogin(formData)
  },

  possLogin: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'UserLogin'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * 带验证码的登录接口（Web端专用）
   * App端使用原有的 possLogin 接口，互不影响
   * @param {FormData} formData - 包含账号、密码、验证码等
   */
  loginWithCaptcha: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'UserLoginWithCaptcha'),
      method: 'post',
      data: formData,
    })
  },

  recoverPass: function (data) {
    var formData = new FormData()
    formData.append('userAccount', data.userAccount)
    formData.append('language', data.language)

    return request({
      url: setting.getFullUrl(TYPE, 'RecoverPassword'),
      method: 'post',
      data: formData,
    })
  },

  resetPassword: function (data) {
    var formData = new FormData()
    formData.append('userAccount', data.userAccount)
    formData.append('resetToken', data.resetToken)
    formData.append('newPassword', data.newPassword)
    formData.append('language', data.language)

    return request({
      url: setting.getFullUrl(TYPE, 'ResetPassword'),
      method: 'post',
      data: formData,
    })
  },

  getPasswordInputMetadata: function () {
    return request({
      url: setting.getFullUrl(TYPE, 'GetPasswordInputMetadata'),
      method: 'get',
    })
  },

  /**
   * SSO 单点登录 - 验证 SSO Token
   * @param {Object} data - SSO 参数
   * @param {string} data.ssoToken - SSO Token
   * @param {string} data.source - 来源平台
   * @param {string} data.language - 语言
   * @param {number} data.timezone - 时区
   */
  ssoLogin: function (data) {
    var formData = new FormData()
    formData.append('ssoToken', data.ssoToken)
    formData.append('provider', data.provider || 'default')
    formData.append('source', data.source || 'external')
    formData.append('language', data.language || 'en-us')
    formData.append('timezone', data.timezone != null ? data.timezone : getEffectiveTimezone())

    return request({
      url: setting.getFullUrl(TYPE, 'SSOLogin'),
      method: 'post',
      data: formData,
    })
  },

  ssoBindLogin: function (data) {
    var formData = new FormData()
    formData.append('ssoToken', data.ssoToken)
    formData.append('provider', data.provider || 'default')
    formData.append('source', data.source || 'external')
    formData.append('userAccount', data.userAccount)
    formData.append('password', data.password)
    formData.append('language', data.language || 'en-us')
    formData.append('timezone', data.timezone != null ? data.timezone : getEffectiveTimezone())

    return request({
      url: setting.getFullUrl(TYPE, 'SSOBindLogin'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * Token 登录 - 使用已有 JWT Token 登录
   * @param {string} token - JWT Token
   * @param {Object} data - 额外参数
   */
  tokenLogin: function (token, data = {}) {
    var formData = new FormData()
    formData.append('language', data.language || 'en-us')
    formData.append('timezone', data.timezone != null ? data.timezone : getEffectiveTimezone())

    return request({
      url: setting.getFullUrl(TYPE, 'TokenLogin'),
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + token,
      },
      data: formData,
    })
  },

  impersonate: function (data) {
    var formData = new FormData()
    formData.append('targetAccount', data.targetAccount)
    if (data.targetSssid) {
      formData.append('targetSssid', data.targetSssid)
    }
    if (data.reason) {
      formData.append('reason', data.reason)
    }
    formData.append('language', data.language || localStorage.getItem('language') || 'en-us')
    formData.append('timezone', data.timezone != null ? data.timezone : getEffectiveTimezone())

    return request({
      url: setting.getFullUrl(TYPE, 'Impersonate'),
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  /**
   * 获取图形验证码
   * @returns {Promise} 返回验证码信息 { captchaId, image }
   */
  getCaptcha: function () {
    return request({
      url: setting.getFullUrl(TYPE, 'GetCaptcha'),
      method: 'get',
    })
  },
}

export default myfunction
